import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';

import { TableStatusCell } from 'components/TableStatusCell/TableStatusCell';

import { AccountActionGuard } from './AccountActionGuard';

export const SubAccountTableRows = ({ rows, setSelectedId, setOpenPopup }) => {
  return rows.map((row) => {
    return (
      <TableRow
        key={row.id}
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
        }}>
        <TableCell scope="row" className="sub-account-table-row-data">
          {row.completeName}
        </TableCell>
        <TableCell align="left" scope="row" lang="de" className="sub-account-table-row-data">
          {row.netzportalEmail || ''}
        </TableCell>
        <TableCell align="left" scope="row" lang="de" className="sub-account-table-row-data">
          <TableStatusCell status={row.salesForceStatus} />
        </TableCell>
        <TableCell align="center" className="action-buttons">
          <AccountActionGuard
            row={row}
            onAction={(id) => {
              setSelectedId(id);
              setOpenPopup(true);
            }}
          />
        </TableCell>
      </TableRow>
    );
  });
};

SubAccountTableRows.propTypes = {
  rows: PropTypes.array.isRequired,
  setSelectedId: PropTypes.func.isRequired,
  setOpenPopup: PropTypes.func.isRequired,
};

SubAccountTableRows.displayName = 'SubAccountTableRow';
